









import { Vue, Component, Prop } from 'vue-property-decorator'
import BlocoDeBagsECrediario from './BlocoDeBagsECrediario.vue'
import type { BagsECrediarioDoCliente } from '@/models'
import { buscarBagsECrediario } from '@/api/painelDoCliente'
import { montarBlocosDeBagsECrediario } from '@/shareds/painel-do-cliente-bags-shareds'

@Component({
	components: {
		BlocoDeBagsECrediario,
	},
})
export default class BagsECrediarioNoCaixa extends Vue {
	@Prop({ type: String, required: true }) clienteId!: string
	@Prop({ type: String, required: true }) lojaId!: string

	dados: BagsECrediarioDoCliente | null = null
	carregando = true

	get blocos() {
		return montarBlocosDeBagsECrediario(this.dados)
	}

	created() {
		this.carregar()
	}

	async carregar() {
		this.carregando = true
		try {
			this.dados = await buscarBagsECrediario(this.clienteId, this.lojaId)
		} catch (erro) {
			console.warn('Falha ao buscar bags e crediário do cliente para o painel do caixa', erro)
			this.dados = null
		} finally {
			this.carregando = false
		}
	}
}
